/* eslint-disable react/prop-types */
import { FC, ReactNode } from 'react'
import { ManageMenuItem } from '.'
import OutsideAlerter from '../OutsideAlerter'
import { Container as ModalContainer } from 'react-modal-promise'
import classNames from 'classnames'
import PageAction from '../PageAction'
import PopoverLink from '../PopoverLink/PopoverLink'
import './Menu.scoped.scss'

const ManageMenuComponent: FC<{
  components: ReactNode[]
  items: ManageMenuItem[]
  title?: ReactNode
  buttonType?: string
}> = ({ items, components, title = 'Manage', buttonType = 'secondary' }) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false)

  return (
    <OutsideAlerter onClickOutside={() => setIsDropdownVisible(false)}>
      <ModalContainer />
      {components ?? null}
      <div
        className="manage-menu"
        onClick={() => setIsDropdownVisible(!isDropdownVisible)}
      >
        <div>
          <button
            className={`manage-menu-button button ${buttonType}`}
            type="button"
            onClick={() => setIsDropdownVisible(!isDropdownVisible)}
          >
            <div className="spacing-horizontal-1 button-title">{title}</div>
            <SvgChevronDown className="smaller margin-left" />
          </button>
        </div>
        {isDropdownVisible && (
          <div className="popup popup-list manage-menu-dropdown">
            <div className="list">
              {items.map(({ title, className, disabledReason, ...rest }, i) => {
                const action = disabledReason && typeof title === 'string' ? title.split(' ')[0].toLowerCase() : ''
                return (
                  <div className={classNames('item', { 'has-disabled-reason': !!disabledReason })} key={`${title}}__${i}`}>
                    <PageAction
                      className={classNames('manage-menu-dropdown-button', className, { disabled: !!disabledReason })}
                      disabled={!!disabledReason}
                      {...rest}
                    >
                      {title}
                    </PageAction>
                    {disabledReason && (
                      <div onClick={(e) => e.stopPropagation()}>
                        <PopoverLink
                          className="disabled-reason-link"
                          content={() => <span>{disabledReason}</span>}
                          noQuestionIcon
                        >
                          Can't be {action}d. Why?
                        </PopoverLink>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </OutsideAlerter>
  )
}
export default ManageMenuComponent
